import { DropdownButton } from "react-bootstrap";
import styled, { css } from "styled-components";

export const HeaderWrapper = styled.div`
  padding: 24px 48px 56px 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .welcome-message {
    color: #2b2928;
    span {
      font-size: 20px;
      font-weight: 400;
      line-height: 36px;
    }
    h3 {
      font-size: 24px;
      font-weight: 600;
      line-height: 36px;
    }
  }
  ${({ smallHeader }) =>
    smallHeader &&
    css`
      padding: 12px 24px 12px 40px;
      box-shadow: 0px 4px 12px 0px #0000000a;
      background-color: #fff;
    `}

  .profile-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    .profile-data {
      color: #2b2928;
      display: flex;
      flex-direction: column;
      gap: 4px;
      .name {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0.374px;
        color: #2b2928;
      }
      .admissiion-id {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #2b2928;
        text-align:right;
      }
    }
    .profile-picture-wrapper {
      width: 48px;
      height: 48px;
      background: linear-gradient(180deg, #fdd8a4 0%, #f0c17e 100%);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 0.4px solid;
      border-image-source: linear-gradient(
        180deg,
        #ffffff 0.96%,
        rgba(255, 255, 255, 0) 98.96%
      );
    }
  }
`;

export const StyledDropdown = styled(DropdownButton)`
  button {
    padding: 0;
    :focus {
      outline: 0 !important;
      box-shadow: none !important;
    }
    :after {
      content: "";
      display: none;
    }
  }
  .dropdown-menu {
    padding: 6px 8px;
    border: transparent;
    top: 16px !important;
    left: 4px !important;
    &.show {
      ::before {
        border-color: rgba(255, 5, 5, 0) rgba(255, 5, 5, 0) rgb(255, 255, 255);
        border-width: 13px;
        margin-left: -6px;
      }
    }
    ::before {
      bottom: 100%;
      right: 10%;
      border: solid transparent;
      content: " ";
      height: 0px;
      width: 0px;
      position: absolute;
      pointer-events: none;
    }
  }
  .dropdown-item {
    padding: 0.5rem;
    &:active {
      background-color: #eef4f9;
    }
  }
`;
